import React from 'react';
import CategoryMenuComponent from './CategoryMenu.component';

/**
 * 에디터용 카테고리 메뉴 컴포넌트
 * 에디터에서는 API 호출 없이 더미 데이터로 미리보기 제공
 */
const CategoryMenuEditor: React.FC<any> = (props) => {
  // 에디터 전용 props 설정
  const editorProps = {
    ...props,
    isEditor: true,
    componentProps: {
      ...props.componentProps,
      loadInEditor: false // 에디터에서는 API 호출하지 않음
    }
  };
  
  return (
    <div className="category-menu-editor-wrapper">
      <CategoryMenuComponent {...editorProps} />
    </div>
  );
};

export default CategoryMenuEditor;